import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '../commons/abstract.service';
import { WalletTypeEnum } from '../models/enum/wallet.type.enum';
import { WalletConfig, WalletKpis, WalletManualLoad, WalletSummary, WalletUsagePoint } from '../models/wallet-kpis.model';
import { WalletEntry } from '../models/wallet-entry.model';
import { Wallet } from '../models/wallet.model';

/**
 * Typed credit wallets — SPEC-2026-08-typed-wallets.
 *
 * Every customer-facing read is scoped to the JWT's company server-side; no
 * `company` parameter is sent or honoured (RF-37).
 */
@Injectable({ providedIn: 'root' })
export class WalletService extends AbstractService<Wallet> {

  getURLBase(): string {
    return '/wallet';
  }

  constructor(http: HttpClient) {
    super(http);
  }

  preCreate(obj: Wallet): void { }

  preUpdate(obj: Wallet): void { }

  // ------------------------------------------------------------- customer

  /** One row per wallet family — powers the Credits list page in one call. */
  getSummary(): Observable<WalletSummary[]> {
    return super.get('/summary');
  }

  listMine(): Observable<Wallet[]> {
    return super.get('/list');
  }

  getByType(type: WalletTypeEnum): Observable<Wallet> {
    return super.get(`/type/${type}`);
  }

  getKpis(type: WalletTypeEnum, params: Record<string, any> = {}): Observable<WalletKpis> {
    return super.getWithParams(`/type/${type}/kpis`, params);
  }

  getUsageSeries(type: WalletTypeEnum, params: Record<string, any> = {}): Observable<WalletUsagePoint[]> {
    return super.getWithParams(`/type/${type}/usage-series`, params);
  }

  // ---------------------------------------------------- admin (root only)

  listByCompanyAdmin(idCompany: string): Observable<Wallet[]> {
    return super.get(`/admin/company/${idCompany}`);
  }

  getKpisAdmin(idCompany: string, params: Record<string, any> = {}): Observable<WalletKpis> {
    return super.getWithParams(`/admin/company/${idCompany}/kpis`, params);
  }

  updateConfigAdmin(idCompany: string, type: WalletTypeEnum, config: WalletConfig): Observable<Wallet> {
    return super.put(`/admin/company/${idCompany}/config/${type}`, config);
  }

  postManualLoad(payload: WalletManualLoad): Observable<{ wallet: Wallet; entry: WalletEntry | null }> {
    return super.post('/admin/load', payload);
  }

  /** @deprecated replaced by getByType — kept until web-admin migrates. */
  getByCompany(idCompany: string): Observable<Wallet> {
    return super.get(`/company/${idCompany}`);
  }
}
